export enum ManagerCampaignsFilter {
  contractorId = 'filters[contractor][id]',
  contractorIdArray = 'filters[contractor][id][]',
  campaignsIdArray = 'filters[campaign][id][]',
  status = 'filters[campaign][status]',
  statusArray = 'filters[campaign][status][]',
  type = 'filters[campaign][type]',
  typeArray = 'filters[campaign][type][]',
  budgetSpentFromTo = 'filters[campaign][budgetSpentPercent]',
  serviceId = 'filters[service][id]',
  serviceIdArray = 'filters[service][id][]',
  managerArray = 'filters[manager][id][]',
  trafficDaysArray = 'filters[campaign][trafficDays][]',
  bidEqualTo = 'filters[campaign][bid][equal]',
  bidGreaterThan = 'filters[campaign][bid][gte]',
  bidLessThan = 'filters[campaign][bid][lte]',
  bidInRangeFrom = 'filters[campaign][bid][range][from]',
  bidInRangeTo = 'filters[campaign][bid][range][to]',
  notActiveNextWeek = 'filters[campaign][inactiveNextWeek]',
  notInCurrentGroup = 'filters[campaign][notInCurrentGroup]',
  doesntHaveArray = 'filters[campaign][doesntHave][]',
}

export enum ContractorCampaignsPageFilter {
  campaignsIdArray = 'filters[campaign][id][]',
  statusArray = 'filters[campaign][status][]',
  serviceIdArray = 'filters[service][id][]',
  typeArray = 'filters[campaign][type][]',
}

export enum ManagerCampaignsSort {
  campaignName = 'sort[campaign][name]',
  contractorName = 'sort[contractor][companyName]',
  status = 'sort[campaign][status]',
  service = 'sort[service][name]',
  companyType = 'sort[campaign][type]',
  bid = 'sort[campaign][bid]',
  thisWeekBudgetSpent = 'sort[campaign][weeklyBudgetSpent]',
  lastWeekBudgetSpent = 'sort[campaign][lastWeekBudgetSpent]',
}

export enum ContractorCampaignsSort {
  campaignName = 'sort[campaign][name]',
  status = 'sort[campaign][status]',
  service = 'sort[service][name]',
  type = 'sort[campaign][type]',
  bid = 'sort[campaign][bid]',
  thisWeekBudgetSpent = 'sort[campaign][weeklyBudgetSpent]',
}
export enum ContractorCampaignsFilter {
  percent80 = 'filters[campaign][budgetSpentPercent][1][from]',
}

export enum ManagerOverlappingCampaignSort {
  bid = 'sort[campaign][bid]',
  groupsCount = 'sort[campaignCounter][groupsCount]',
  lastWeekBudgetSpentPercent = 'sort[campaignCounter][lastWeekSpentBudgetPercent]',
  name = 'sort[campaign][name]',
  normalizedBid = 'sort[campaign][normalizedBid]',
  status = 'sort[campaign][status]',
  targetAreaOverlap = 'sort[campaign][targetAreaOverlap]',
  thisWeekBudgetSpentPercent = 'sort[campaignCounter][thisWeekSpentBudgetPercent]',
  type = 'sort[campaign][type]',
  yesterdayItemsCount = 'sort[campaign][yesterdayItemsCount]',
  companyName = 'sort[contractor][companyName]',
}

export enum ManagerOverlappingFilter {
  contractorIdArray = 'filters[contractor][id][]',
  campaignId = 'filters[campaign][id][]',
  serviceIdArray = 'filters[service][id][]',
}

export enum ManagerOverlappingFilterQuery {
  contractorIdArray = 'filters[contractor][id][]',
  campaignId = 'filters[campaign][id][]',
  type = 'filters[campaign][type][]',
  serviceIdArray = 'filters[service][id][]',
}
